export type BadgeSeverity = 'primary' | 'secondary' | 'success' | 'brown' | 'danger' | 'info' | 'white';
export type BadgeSize = 'xs' | 'sm' | 'md' | 'lg'
export type BadgeContentPosition = 'left' | 'right'
export type BadgeBehaviour = 'static' | 'responsive'

export const severitySwitch = (severity: BadgeSeverity): string => {
  switch (severity) {
    case 'primary': return 'bg-yellow-700 text-brown-600'
    case 'secondary': return 'bg-yellow-300 text-brown-600'
    case 'success': return 'bg-green-500 text-brown-600'
    case 'brown': return 'bg-brown-600 text-yellow-300'
    case 'danger': return 'bg-red-500 text-white'
    case 'info': return 'bg-blue-500 text-white'
    case 'white': return 'bg-white text-gray-800'
    default: return 'bg-yellow-700 text-brown-600'
  }
};


const SIZE_CLASSES: Record<BadgeBehaviour, Record<BadgeSize, { size: string; label: string; }>> = {
  static: {
    lg: { size: 'h-8 min-w-8 px-3', label: 'text-sm' },
    md: { size: 'h-6 min-w-6 px-2', label: 'text-xs' },
    sm: { size: 'h-3.5 min-w-3.5 px-1', label: 'text-2xs' },
    xs: { size: 'w-1.5 h-1.5 ', label: '' }
  },
  responsive: {
    lg: { size: 'h-6 min-w-6 px-2 lg:h-8 lg:min-w-8 lg:px-3', label: 'text-xs lg:text-sm' },
    md: { size: 'h-6 min-w-6 px-2', label: 'text-xs' },
    sm: { size: 'h-3.5 min-w-3.5 px-1', label: 'text-2xs' },
    xs: { size: 'w-1.5 h-1.5 ', label: '' }
  },
};

export function getSizeSet(size: BadgeSize, behaviour: BadgeBehaviour) {
  return SIZE_CLASSES[behaviour][size];
}
